import React, { memo, SVGProps } from 'react'

export const ChevronLeft = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.7952 17.1168C14.0765 17.3981 14.5325 17.3981 14.8138 17.1168C15.095 16.8355 15.095 16.3795 14.8138 16.0982L10.7136 11.999L14.8138 7.89984C15.095 7.61856 15.095 7.16256 14.8138 6.88128C14.6736 6.74112 14.4893 6.67008 14.305 6.67008C14.1206 6.67008 13.9363 6.74016 13.7962 6.88128L9.1872 11.4893C9.05184 11.6246 8.976 11.807 8.976 11.9981C8.976 12.1891 9.05184 12.3725 9.1872 12.5069L13.7962 17.1149L13.7952 17.1168Z"
      fill="currentColor"
    />
  </svg>
))
